import { useQuery } from "@tanstack/react-query";
import Table from "../../../NTable";
import { useNewTable } from "../../../NTable/hook";
import useApi from "../../../../utils/api";
// import { useColumns } from "@/features/Profile/sections/PBJ/columns";

function PBJ({ user }: any) {
    const { authGet } = useApi();
    const columns = []; // useColumns({ edit: undefined, remove: undefined });

    const { data, isLoading } = useQuery({
        queryKey: [`/users/${user?.id}/pbj-code`],
        queryFn: ({ queryKey }: any) => authGet(queryKey[0]),
        enabled: !!user?.id,
    });

    const raw = Array.isArray(data) ? data : (data?.result ?? data?.data ?? []);

    const table = useNewTable({
        data: raw,
        totalItems: raw.length,
        columns,
        loading: isLoading,
        enableRowSelection: false,
        enableSorting: false,
    } as any);

    return (
        <div className="tw-overflow-hidden">
            <Table
                table={table}
                pagination={false}
                hasChangedDateFilter={undefined}
                setHasChangedDateFilter={() => {}}
            />
        </div>
    );
}

export default PBJ;
